import 'css-chunksrc/client/pages/searchPage/filters/styles.scss';export default {
  "filters": "_filters_1vsg6_1",
  "types": "_types_1vsg6_5"
};